import { isEmptyStringOrNullish } from "@finway-group/shared/lib/utils/common"
import {
    MAX_DISCOUNT_DURATION_DAYS,
    MAX_DISCOUNT_PERCENTAGE,
    MIN_DISCOUNT_DURATION_DAYS,
    MIN_DISCOUNT_PERCENTAGE,
    isDiscountPercentageValid,
    isDiscountPeriodValid,
} from "@finway-group/shared/lib/utils/validators"
import { FormInstance, Rule } from "antd/lib/form"
import { InternalNamePath } from "antd/lib/form/interface"
import { i18n } from "~Shared/locales/i18n"

export const createDiscountRules = (formInstance: FormInstance, namePath: InternalNamePath, allowBothEmpty = true) => ({
    percentage: [
        {
            validator: (_rule, value: string) => {
                if (isEmptyStringOrNullish(value)) {
                    const period = formInstance.getFieldValue([...namePath, "period"])
                    if (isEmptyStringOrNullish(period) && allowBothEmpty) {
                        // Resolve if both percentage and period are empty
                        return Promise.resolve()
                    }

                    return Promise.reject(new Error(i18n.t("validation:required")))
                }

                if (!isDiscountPercentageValid(value)) {
                    return Promise.reject(new Error(i18n.t("validation:numeric_min_max", { min: MIN_DISCOUNT_PERCENTAGE, max: MAX_DISCOUNT_PERCENTAGE })))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    period: [
        {
            validator: (_rule, value: string) => {
                if (isEmptyStringOrNullish(value)) {
                    const percentage = formInstance.getFieldValue([...namePath, "percentage"])
                    if (isEmptyStringOrNullish(percentage) && allowBothEmpty) {
                        // Resolve if both percentage and period are empty
                        return Promise.resolve()
                    }

                    return Promise.reject(new Error(i18n.t("validation:required")))
                }

                if (!Number.isInteger(Number(value))) {
                    return Promise.reject(new Error(i18n.t("validation:integer")))
                }

                if (!isDiscountPeriodValid(value)) {
                    return Promise.reject(new Error(i18n.t("validation:numeric_min_max", { min: MIN_DISCOUNT_DURATION_DAYS, max: MAX_DISCOUNT_DURATION_DAYS })))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})

export const DiscountFormRulesStrict = (formInstance: FormInstance, namePath: InternalNamePath) => createDiscountRules(formInstance, namePath, false)
